export default __webpack_public_path__ + "static/fingerprint-mug-1-c0f249623600e665337881bd3d54a285.jpg";